import React from "react";
import { Table, Button, Modal, Form, Input, Checkbox } from "antd";
import useRoleManagement from "./logic/useRoleManagement";
import "./RoleManagement.scss";

const RoleManagement = () => {
  const {
    roles,
    columns,
    handleSearchChange,
    onChange,
    handleAddRole,
    handleEditRole,
    isAddModalVisible,
    setIsAddModalVisible,
    isEditModalVisible,
    setIsEditModalVisible,
    editingRole,
    setEditingRole,
    availablePermissions,
  } = useRoleManagement();

  const [addForm] = Form.useForm();
  const [editForm] = Form.useForm();

  // Submit handler for adding a role
  const handleAddSubmit = (values) => {
    handleAddRole(values);
    addForm.resetFields();
  };

  // Submit handler for editing a role
  const handleEditSubmit = (values) => {
    setEditingRole({ ...editingRole, ...values });
    handleEditRole();
  };

  return (
    <div className="role-management-container">
      <div className="table-top-section">
        <Input.Search
          placeholder="Search..."
          onChange={handleSearchChange}
          style={{ margin: "20px 0", width: "300px" }}
        />
        <Button type="primary" onClick={() => setIsAddModalVisible(true)}>
          Add Role
        </Button>

      </div>

      <Table
        dataSource={roles.data}
        columns={columns}
        pagination={{
          current: roles.meta.page,
          pageSize: roles.meta.take,
          total: roles.meta.itemCount,
        }}
        onChange={onChange}
      />

      {/* Modal for adding a role */}
      <Modal
        title="Add Role"
        visible={isAddModalVisible}
        onCancel={() => setIsAddModalVisible(false)}
        onOk={() => addForm.submit()}
      >
        <Form form={addForm} onFinish={handleAddSubmit}>
          <Form.Item
            name="roleName"
            label="Role Name"
            rules={[{ required: true, message: "Please enter the role name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="roleDescription"
            label="Role Description"
            rules={[{ required: true, message: "Please enter the description" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="permissions"
            label="Permissions"
            rules={[{ required: true, message: "Please select permissions" }]}
          >
            <Checkbox.Group options={availablePermissions} />
          </Form.Item>
        </Form>
      </Modal>

      {/* Modal for editing a role */}
      <Modal
        title="Edit Role"
        visible={isEditModalVisible}
        onCancel={() => setIsEditModalVisible(false)}
        onOk={() => editForm.submit()}
      >
        <Form form={editForm} onFinish={handleEditSubmit} initialValues={editingRole}>
          <Form.Item
            name="roleName"
            label="Role Name"
            rules={[{ required: true, message: "Please enter the role name" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="roleDescription"
            label="Role Description"
            rules={[{ required: true, message: "Please enter the description" }]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            name="permissions"
            label="Permissions"
            rules={[{ required: true, message: "Please select permissions" }]}
          >
            <Checkbox.Group options={availablePermissions} />
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
};

export default RoleManagement;